import i18n from "i18next";

export function getOnboardingSystemPrompt(): string {
	const origin = typeof window !== "undefined" ? window.location.origin : "";
	return i18n.t("onboarding:system_prompt", {
		origin,
		feedUrl: `${origin}/demo/feed.xml`,
	});
}

export interface OnboardingSuggestion {
	/** Bold label shown on the chip */
	label: string;
	/** Subtitle shown below the label */
	subtitle: string;
	/** Text actually sent to the agent (defaults to label if omitted) */
	prompt?: string;
}

export function getOnboardingSuggestions(): Record<
	number,
	OnboardingSuggestion[]
> {
	return {
		0: [
			{
				label: i18n.t("onboarding:sug_0_import_label"),
				subtitle: i18n.t("onboarding:sug_0_import_subtitle"),
			},
			{
				label: i18n.t("onboarding:sug_0_formats_label"),
				subtitle: i18n.t("onboarding:sug_0_formats_subtitle"),
			},
		],
		1: [
			{
				label: i18n.t("onboarding:sug_1_search_label"),
				subtitle: i18n.t("onboarding:sug_1_search_subtitle"),
			},
			{
				label: i18n.t("onboarding:sug_1_about_label"),
				subtitle: i18n.t("onboarding:sug_1_about_subtitle"),
			},
		],
		2: [
			{
				label: i18n.t("onboarding:sug_2_order_label"),
				subtitle: i18n.t("onboarding:sug_2_order_subtitle"),
			},
			{
				label: i18n.t("onboarding:sug_2_how_label"),
				subtitle: i18n.t("onboarding:sug_2_how_subtitle"),
			},
		],
		3: [
			{
				label: i18n.t("onboarding:sug_3_export_label"),
				subtitle: i18n.t("onboarding:sug_3_export_subtitle"),
			},
			{
				label: i18n.t("onboarding:sug_3_formats_label"),
				subtitle: i18n.t("onboarding:sug_3_formats_subtitle"),
			},
		],
		4: [
			{
				label: i18n.t("onboarding:sug_4_invite_label"),
				subtitle: i18n.t("onboarding:sug_4_invite_subtitle"),
			},
			{
				label: i18n.t("onboarding:sug_4_roles_label"),
				subtitle: i18n.t("onboarding:sug_4_roles_subtitle"),
			},
		],
		5: [
			{
				label: i18n.t("onboarding:sug_5_more_label"),
				subtitle: i18n.t("onboarding:sug_5_more_subtitle"),
			},
			{
				label: i18n.t("onboarding:sug_5_settings_label"),
				subtitle: i18n.t("onboarding:sug_5_settings_subtitle"),
			},
		],
	};
}

/** @deprecated Use getOnboardingSuggestions() for reactive i18n */
export const ONBOARDING_SUGGESTIONS = getOnboardingSuggestions();

function getStepHints(): Record<number, string> {
	return {
		0: i18n.t("onboarding:step_hint_0"),
		1: i18n.t("onboarding:step_hint_1"),
		2: i18n.t("onboarding:step_hint_2"),
		3: i18n.t("onboarding:step_hint_3"),
		4: i18n.t("onboarding:step_hint_4"),
	};
}

export function getOnboardingPageContext(
	step: number,
): Record<string, unknown> {
	const hints = getStepHints();
	return {
		onboarding: true,
		currentStep: step,
		systemPrompt: getOnboardingSystemPrompt(),
		hint:
			hints[step] ??
			i18n.t("onboarding:step_hint_fallback", { step: step + 1 }),
	};
}
